"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _default = function _default(_ref) {
  var image = _ref.image,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center justify-center w-full h-full"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: title,
    className: "h-40vh",
    style: {
      maxHeight: 250,
      minHeight: 200
    }
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-lg text-dark font-bold"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-dark max-w-xl text-center"
  }, subtitle));
};

exports["default"] = _default;
//# sourceMappingURL=EmptyList.js.map